import React, { PropTypes } from 'react';
import { Dialog, IconButton } from 'material-ui';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { saveAsANewTemplate, publishDraft as publishDraftAction } from '../../../../stores/contracting/dialogs/dialog-constants';
import { downloadContractPdf as downloadContractPdfAction } from '../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import {
  sendReviewRatesEmail,
} from '../../__storeFiles__/actions';
import actions from '../../../../stores/contracting/root-actions-map';
import { onUserInput } from '../../../../stores/userInputActions';
import SaveAsTemplate from '../publish-draft-content/save-as-template';
import DownloadPDFAsDraft from '../publish-draft-content/downloadPDFAsDraft';
import DraftComplete from '../publish-draft-content/draft-complete';
import SendUpdates from '../publish-draft-content/send-updates';

const PublishDraftDialog = (props) => {
  const { publishDraftDialog, onRequestClose, contractId, saveAsANewTemplateWithDispatch, makeACopyForBuyer, downloadContractPdf, forBuyer, ...extraProps } = props;
  const { open, title, newDraftStartDate, newDraftEndDate } = publishDraftDialog;
  const ContentNode = (() => {
    switch (title) {
      case 'Save Template':
        return SaveAsTemplate;
      case 'Finalise Template':
        return DraftComplete;
      case 'Send Updates':
        return SendUpdates;
      case 'Download PDF':
      default:
        return DownloadPDFAsDraft;
    }
  })();
  const activeDraft = Boolean(extraProps.sentPartners && extraProps.sentPartners.length);
  return (
    <Dialog
      autoScrollBodyContent
      modal
      bodyStyle={{ padding: '0', paddingBottom: '12px' }}
      contentStyle={{ maxWidth: '880px', width: '700px' }}
      open={open}
      onRequestClose={onRequestClose}
      title={<div className="flex-tc-sb" style={{ backgroundColor: '#00BCD4', color: 'white', fontSize: '18px', padding: '2%' }} >
        {(() => {
          if (title === 'Finalise Template' && !publishDraftDialog.draftApproved && !activeDraft) {
            return 'Want an expert to review your rates?';
          }
          if (title === 'Save Template') {
            if (forBuyer) return 'Make a copy of this rate sheet';
            return 'Make a copy of this template';
          }
          return title;
        })()}
        <IconButton
          iconClassName="tc-icon-close"
          style={{ padding: '4px', width: '30px', height: '30px' }}
          iconStyle={{ color: 'white', fontSize: '20px' }}
          onTouchTap={onRequestClose}
        />
      </div>}
    >
      <ContentNode
        {...extraProps}
        forBuyer={forBuyer}
        onRequestClose={onRequestClose}
        downloadContractPdf={(anchorEl) => {
          downloadContractPdf(contractId, 'publish-ready', anchorEl);
        }}
        saveAsANewTemplate={() => {
          if (forBuyer) {
            makeACopyForBuyer({
              contractId,
              startDate: newDraftStartDate,
              endDate: newDraftEndDate,
              templateId: publishDraftDialog.templateId,
              isDummyTemplate: publishDraftDialog.isDummyTemplate,
            });
          } else {
            saveAsANewTemplateWithDispatch({
              contractId,
              templateName: publishDraftDialog.templateName || extraProps.currentTemplateName,
              startDate: newDraftStartDate,
              endDate: newDraftEndDate,
              shouldClearDates: publishDraftDialog.shouldClearDates,
            });
          }
        }}
        contractId={contractId}
        {...publishDraftDialog}
      />
    </Dialog>
  );
};

PublishDraftDialog.propTypes = {
  publishDraftDialog: PropTypes.object,
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  draftErrors: PropTypes.object,
  downloadContractPdf: PropTypes.func,
  saveAsANewTemplateWithDispatch: PropTypes.func,
  sendReviewRatesEmail: PropTypes.func,
  forBuyer: PropTypes.bool,
  makeACopyForBuyer: PropTypes.func,
};

const mapStateToProps = ({ contracting, config, user }, { reducerName }) => ({
  draftErrors: reducerName ? contracting[reducerName].get('draftErrors').toJS() : {},
  publishDraftDialog: contracting.publishDraftDialog.toJS(),
  leftNav: reducerName ? contracting[reducerName].get('leftNav').toJS() : {},
  apiUrl: config.get('apiUrl'),
  contractId: reducerName ? contracting[reducerName].getIn(['leftNav', 'contractId']) : contracting.publishDraftDialog.get('contractId'),
  productType: reducerName ? contracting[reducerName].getIn(['rightSideContent', 'productType']) : '',
  locationId: reducerName ? contracting[reducerName].getIn(['leftNav', 'locationId']) : '',
  freeContractsLeft: user.get('freeContractsLeft'),
  billingPlan: user.get('billingPlan'),
});

const mapDispatchToProps = dispatch => ({
  onRequestClose: onUserInput(dispatch, actions, 'closePublishDraftDialog'),
  onFieldChange: onUserInput(dispatch, actions, 'onTextFieldChangePublishDraftDialog'),
  onBCCSelfCheck: onUserInput(dispatch, actions, 'onBCCSelfCheck'),
  includeNotesCheck: onUserInput(dispatch, actions, 'includeNotesCheck'),
  includeMultiLocNotesCheck: onUserInput(dispatch, actions, 'includeMultiLocNotesCheck'),
  includeGeneralNoteCheck: onUserInput(dispatch, actions, 'includeGeneralNoteCheck'),
  notEnoughFreeContractsError: onUserInput(dispatch, actions, 'notEnoughFreeContracts'),
  goToSendUpdates: () => dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' }),
  updateProps: payload => dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload }),
  makeACopyForBuyer: payload => dispatch({ type: '{dummy_account} makeACopyForBuyer', payload }),
  saveAsANewTemplateWithDispatch: payload => dispatch(saveAsANewTemplate(payload)),
  publishDraft: (...args) => dispatch(publishDraftAction(...args)),
  downloadContractPdf: (...args) => dispatch(downloadContractPdfAction(...args)),
  sendReviewRatesEmail: (...args) => dispatch(sendReviewRatesEmail(...args)),
  push: (...args) => dispatch(push(...args)),
});
PublishDraftDialog.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps, mapDispatchToProps)(PublishDraftDialog);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/publish-draft-dialog.jsx